const TAG_COLORS = ["purple"];

export const getTagColor = (key: string) =>
  TAG_COLORS[
    key.split("").reduce((sum, char) => sum + char.charCodeAt(0), 0) %
      TAG_COLORS.length
  ];
